const MIME_TYPES: Record<string, string> = {
  pdf: 'application/pdf',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ppt: 'application/vnd.ms-powerpoint',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  png: 'image/png',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  gif: 'image/gif',
  mp4: 'video/mp4',
  mp3: 'audio/mpeg',
  zip: 'application/zip'
};

const isReactNativeWebView = (): boolean =>
  typeof window !== 'undefined' && window.isReactNativeWebView === true;

const getMimeType = (fileName: string): string => {
  const ext = fileName.split('.').pop()?.toLowerCase() ?? '';

  return MIME_TYPES[ext] ?? 'application/octet-stream';
};

const handleMobileDownload = async (url: string, fileName: string) => {
  if (!window.ReactNativeWebView) return;

  try {
    const mimeType = getMimeType(fileName);

    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        type: 'DOWNLOAD_FILE',
        url,
        fileName,
        mimeType
      })
    );
  } catch (error) {
    console.error('Error al descargar el archivo:', error);
  }
};

const handleWebDownload = async (url: string, suggestedName?: string) => {
  try {
    const response = await fetch(url);
    const blob = await response.blob();
    const objectUrl = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = objectUrl;
    anchor.download = suggestedName || '';
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
    window.URL.revokeObjectURL(objectUrl);
  } catch {
    const anchor = document.createElement('a');
    anchor.href = url;
    if (suggestedName) anchor.setAttribute('download', suggestedName);
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
  }
};

export const downloadFile = async (url: string, suggestedName?: string) => {
  const fileName = suggestedName || url.split('/').pop() || 'download';

  if (isReactNativeWebView()) {
    await handleMobileDownload(url, fileName);
  } else {
    await handleWebDownload(url, suggestedName);
  }
};
